import { Card } from '@getdokan/dokan-ui';

const QuoteDetailsSkeleton: React.FC = () => {
    return (
        <div className="bg-white rounded-lg space-y-6 mt-4">
            { /* Header */ }
            <div className="flex justify-between items-center border bg-white rounded-lg shadow p-4">
                <div className="space-y-3">
                    <div className="flex items-center gap-4">
                        <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-4 w-20 bg-gray-100 rounded animate-pulse"></div>
                    </div>
                    <div className="flex items-center gap-4">
                        { /*<div className="h-3 w-32 bg-gray-200 rounded animate-pulse"></div>*/ }
                        <div className="h-3 w-60 bg-gray-100 rounded-full animate-pulse"></div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="h-10 w-40 bg-gray-200 rounded animate-pulse"></div>
                    <div className="h-10 w-32 bg-gray-100 rounded animate-pulse"></div>
                </div>
            </div>

            { /* Info Cards */ }
            <div className="grid grid-cols-3 gap-6">
                { [ 1, 2, 3 ].map( ( i ) => (
                    <div
                        key={ i }
                        className="border bg-white rounded-lg shadow p-4 flex items-center gap-3"
                    >
                        <div className="h-10 w-10 bg-gray-200 rounded-full animate-pulse"></div>
                        <div className="space-y-2 flex-1">
                            <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                            <div className="h-3 w-24 bg-gray-100 rounded animate-pulse"></div>
                        </div>
                    </div>
                ) ) }
            </div>

            { /* Products Table */ }
            <div className="border rounded-lg overflow-hidden shadow">
                <table className="w-full dataviews-view-table">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="p-4 text-left">
                                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="p-4 text-left">
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="p-4 text-left">
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="p-4 text-left">
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="p-4 text-left">
                                <div className="h-4 w-8 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="p-4 text-left">
                                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { [ ...Array( 3 ) ].map( ( _, index ) => (
                            <tr key={ index } className="border-t">
                                <td className="p-4">
                                    <div className="flex gap-3">
                                        <div className="h-12 w-12 bg-gray-100 rounded animate-pulse"></div>
                                        <div className="space-y-2 self-center">
                                            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                                            <div className="h-3 w-16 bg-gray-100 rounded animate-pulse"></div>
                                            <div className="h-3 w-20 bg-gray-100 rounded animate-pulse"></div>
                                        </div>
                                    </div>
                                </td>
                                <td className="p-4">
                                    <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
                                </td>
                                <td className="p-4">
                                    <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                                </td>
                                <td className="p-4">
                                    <div className="h-10 w-24 bg-gray-100 rounded animate-pulse"></div>
                                </td>
                                <td className="p-4">
                                    <div className="h-4 w-8 bg-gray-200 rounded animate-pulse"></div>
                                </td>
                                <td className="p-4">
                                    <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
                                </td>
                            </tr>
                        ) ) }
                    </tbody>
                </table>
            </div>

            { /* Shipping Cost & Total */ }
            <div className="flex flex-col gap-2 border shadow px-6 py-4 rounded-lg">
                <div className="flex justify-between items-center border-b pb-4">
                    <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                    <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="flex justify-between items-center pt-2">
                    <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                    <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>

            { /* Shipping Details */ }
            <Card className="rounded-lg shadow overflow-hidden">
                <Card.Header>
                    <Card.Title className="m-0 flex items-center gap-2">
                        <div className="h-5 w-5 bg-gray-200 rounded-full animate-pulse"></div>
                        <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className="space-y-3">
                        { [ 1, 2, 3, 4 ].map( ( i ) => (
                            <div key={ i } className="flex items-center gap-3">
                                <div className="h-5 w-5 bg-gray-100 rounded-full animate-pulse"></div>
                                <div className="h-4 w-56 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                        ) ) }
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default QuoteDetailsSkeleton;
